
export default function Hero() {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/923bc427148e3afc10d55a3f703948f0.jpg)'
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      
      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center w-full">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-white mb-6 leading-tight">
          Cuidar da mente é o primeiro passo para uma vida mais leve e equilibrada
        </h1>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-3xl mx-auto font-light">
          Atendimento psicológico com abordagem em Terapia Cognitivo-Comportamental para adultos, grupos e palestras.
        </p>
        
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="https://wa.me/5511959099459"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#A8D5E2] text-gray-800 px-8 py-4 rounded-full text-base font-medium hover:bg-[#8FC5D4] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Agendar Atendimento
          </a>
          <a
            href="https://wa.me/5511959099459"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-medium hover:bg-white/20 transition-all duration-300 border border-white/30 whitespace-nowrap cursor-pointer"
          >
            Falar no WhatsApp
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-3xl text-white/70"></i>
      </div>
    </section>
  );
}
